import { SHA256 } from "crypto-js";
import { useLocalstorageState } from "rooks";

export interface Password {
  isAllowed: () => boolean;
  check: (rawPassword?: string) => void;
  getHash: () => string;
}

type PersistedPasswordHash = {
  hash: string;
};

export const usePassword = (): Password => {
  const getSHA256Hash = (input: string) => SHA256(input).toString();

  const [persistedPasswordHash, setPersistedPasswordHash] =
    useLocalstorageState<PersistedPasswordHash>("PersistedPasswordHash");

  const password = {
    isAllowed: () => {
      if (!persistedPasswordHash || !persistedPasswordHash.hash) {
        return false;
      }
      return (
        getSHA256Hash(persistedPasswordHash.hash) ===
        process.env.REACT_APP_PASSWORD_VALUE
      );
    },
    check: (rawPassword?: string) => {
      if (!rawPassword) {
        return;
      }
      const singleHashed = getSHA256Hash(rawPassword);
      const doubleHashed = getSHA256Hash(singleHashed);
      if (doubleHashed === process.env.REACT_APP_PASSWORD_VALUE) {
        setPersistedPasswordHash({
          hash: singleHashed,
        });
      }
    },
    getHash: () => {
      if (!persistedPasswordHash) {
        return "";
      }
      return persistedPasswordHash.hash;
    },
  };

  return password;
};
